module.exports = __webpack_public_path__ + "static/media/error.21a84586.jpg";